// extracted by mini-css-extract-plugin
export var addressFields = "_jb-0";
export var animationContainer = "_jb-1";
export var footer = "_jb-2";
export var lineItems = "_jb-3";
export var modalContent = "_jb-4";
export var orderName = "_jb-5";
export var strong = "_jb-6";
export var warning = "_jb-7";